import modelBaseV2 from './model-base-v2.model';
import { v4 as uuidv4 } from 'uuid';

var DownloadModel = {

  downloadByFileId: (fileId, fileName = '') => {
    if (!fileName) {
      fileName = uuidv4() + '.zip';
    }

    return modelBaseV2.getDownloadPublic(`/api/file/download?fileId=${encodeURIComponent(fileId)}`, undefined, fileName);
  },
}

export default DownloadModel;
